function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
var LEGACY_BASE = 'https://unienceproduction-images-dhnw29xkhb2o.s3.amazonaws.com';
var getResourcesURL = function getResourcesURL(id, factor, query) {
  var size = query.w ? "w".concat(factor * query.w) : query.h ? "h".concat(factor * query.h) : null;
  if (size) {
    var baseUrl = "".concat(getSuperPartnerBaseURL(), "/v4/resources/media/images/").concat(id, "-").concat(size);
    var url = query.format ? "".concat(baseUrl, "-").concat(query.format) : baseUrl;
    return url;
  }
  return null;
};
var getSanitizedSrc = function getSanitizedSrc(src) {
  if (!src.includes('/')) {
    return "".concat(getSuperPartnerBaseURL(), "/image/").concat(src);
  }
  if (src.startsWith('/image/')) {
    return getSuperPartnerBaseURL() + src;
  }
  if (src.startsWith(LEGACY_BASE)) {
    return src.replace(LEGACY_BASE, "".concat(getSuperPartnerBaseURL(), "/image/"));
  }
  return src.replace('http://', 'https://');
};
export var getImageUrl = function getImageUrl(image, options) {
  var _ref = options || {},
    width = _ref.width,
    height = _ref.height,
    format = _ref.format,
    _ref$factor = _ref.factor,
    factor = _ref$factor === void 0 ? 2 : _ref$factor;
  if (!image || image === 'null') {
    return null;
  }
  var sanitized = getSanitizedSrc(image);
  var withParams = width || height;
  if (!withParams) {
    return sanitized;
  }
  var regexp = new RegExp('/image/([a-zA-Z0-9-]+)$', 'g');
  var match = regexp.exec(sanitized);
  var _ref2 = match || [],
    _ref3 = _slicedToArray(_ref2, 2),
    _ = _ref3[0],
    imageId = _ref3[1];
  if (imageId === 'null') {
    return null;
  }
  if (!imageId) {
    return sanitized;
  }
  var query = {};
  if (format) {
    query.format = format;
  }
  if (width) {
    query.w = width;
  }
  if (height) {
    query.h = height;
  }
  if (width === height && width > 0 && width < 240) {
    query.sharp = 1;
    query.format = 'png';
  }
  var url = getResourcesURL(imageId, factor, query);
  return url ? url : sanitized;
};